import { z } from 'zod';
import { HitpointsEvent } from '../event.js';
const RecipePinned = HitpointsEvent.extend({
    type: z.literal('RecipePinned'),
    recipeId: z.string().uuid(),
});
const RecipeUnpinned = HitpointsEvent.extend({
    type: z.literal('RecipeUnpinned'),
    recipeId: z.string().uuid(),
});
const PinnedRecipeMoved = HitpointsEvent.extend({
    type: z.literal('PinnedRecipeMoved'),
    recipeId: z.string().uuid(),
    index: z.number().min(0),
});
export const pinnedRecipesTypeMap = {
    RecipePinned,
    RecipeUnpinned,
    PinnedRecipeMoved,
};
const pinnedRecipesEventTypes = Object.keys(pinnedRecipesTypeMap);
export function isPinnedRecipesEvent(event) {
    return pinnedRecipesEventTypes.includes(event.type);
}
//# sourceMappingURL=pinnedRecipes.events.js.map